import styled from 'styled-components';

export const TitleHeading = styled.div`
  display: flex;
  gap: 5px;
  align-items: center;
  position: relative;
  font-family: var(--font-family-ibm_plex_sans);
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
  cursor: pointer;
`;
export const TasksImg = styled.img`
  width: 24px;
  height: 24px;
  gap: 0px;
  opacity: 0px;
`;
